/* Dropmagic Asset | Version: 1.0.0 */
// https://image-compare-viewer.netlify.app/
if (!customElements.get('dm-before-after')) {
  customElements.define(
    'dm-before-after',
    class DMBeforeAfter extends HTMLElement {
      constructor() {
        super();
        // Initialize ImageCompare
        try {
          // const speed = this.dataset.speed ?? 100;

          console.log('this.dataset dm-before-after', this.dataset.sliderLineColor);
          const element = this;

          new ImageCompare(element, {
            controlColor: this.dataset.sliderLineColor,
            controlShadow: false,
            addCircle: true,
            addCircleBlur: true,
            smoothingAmount: 100
          }).mount();

          
        } catch (error) {
          console.error('Error initializing dm-before-after:', error);
        }
      }
    }
  );
}
